import { AxiosResponse, AxiosInstance } from 'axios';
import OrderDetailModel from '@/models/OrderDetailModel';
import PagedResult from '@/models/PagedResult';
import { OrderFilter } from '@/common/enum';
import IncompleteOrderModel from '@/models/IncompleteOrderModel';

export default class OrderService {
  private axiosInstance: AxiosInstance;

  public constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  public async PlaceOrder(orderDetail: OrderDetailModel): Promise<string> {
    const url: string = `Order`;
    const res: AxiosResponse<string> = await this.axiosInstance.post<string>(
      url,
      orderDetail,
    );
    if (res.status === 201) {
      return res.data;
    } else {
      throw new Error(`unexpected result from API: (${res.status})`);
    }
  }

  public async GetOrder(token: string): Promise<OrderDetailModel | null> {
    // tslint:disable-next-line: max-line-length
    const res: void | AxiosResponse<
      OrderDetailModel
    > = await this.axiosInstance.get<OrderDetailModel>(`Order/${token}`);
    return res.data;
  }

  public async GetOrderById(id: number): Promise<OrderDetailModel | null> {
    // tslint:disable-next-line: max-line-length
    const res: void | AxiosResponse<
      OrderDetailModel
    > = await this.axiosInstance.get<OrderDetailModel>(`Order/${id}`);
    return res.data;
  }

  public async List(filters: any): Promise<PagedResult<OrderDetailModel[]>> {
    let url = `order`;

    const filterString: string[] = [];

    if ('size' in filters) {
      filterString.push(`Size=${filters.size}`);
    }
    if ('keyword' in filters && filters.keyword) {
      filterString.push(`Keyword=${filters.keyword}`);
    }
    if ('isOrdered' in filters) {
      if (filters.isOrdered === OrderFilter.Ordered) {
        filterString.push(`IsOrdered=true`);
      } else if (filters.isOrdered === OrderFilter.Pending) {
        filterString.push(`IsOrdered=false`);
      }
    }
    if ('offset' in filters && filters.offset) {
      filterString.push(`offset=${filters.offset}`);
    }

    if (filterString.length > 0) {
      url += `?${filterString.join('&')}`;
    }
    const res: AxiosResponse<
      PagedResult<OrderDetailModel[]>
    > = await this.axiosInstance.get<PagedResult<OrderDetailModel[]>>(url);
    return res.data;
  }

  public async changeStatus(
    orderId: number,
    status: boolean,
  ): Promise<OrderDetailModel | null> {
    const res: AxiosResponse<OrderDetailModel> = await this.axiosInstance.post<
      OrderDetailModel
    >(`order/${orderId}/status/${status.toString()}`);
    return res.data;
  }

  public async AddIncompleteOrder(
    data: IncompleteOrderModel,
  ): Promise<boolean> {
    const url: string = `Order/incomplete-order`;
    const res: AxiosResponse<object | null> = await this.axiosInstance.post<
      object | null
    >(url, data);
    return res.data ? true : false;
  }
}
